import classNames from "classnames";
import { slugify } from "helpers/utils";
import { AttributeOption } from "interfaces/products";
import { ListBox, ListBoxItem } from "react-aria-components";
import { CloudinaryImage } from "react-tiny-cloudinary";

import type { AttributePanelContentProps } from ".";

import styles from "./attribute-panel.module.scss";

export function AttributePanelGrid({
    options,
    compact,
    ...props
}: AttributePanelContentProps) {
    return (
        <ListBox
            {...props}
            layout="grid"
            orientation="vertical"
            className={styles.attributePanelGrid}
        >
            {[...options].map((item) => (
                <AttributePanelGridOption key={item.id} option={item} />
            ))}
        </ListBox>
    );
}

function AttributePanelGridOption({ option }: { option: AttributeOption }) {
    return (
        <ListBoxItem
            id={option.id} // this does NOT translate to the id of the dom element
            textValue={option.option}
            className={classNames({
                [styles.attributePanelGridItem]: true,
                "al-pdp-vc__panel-item": true,
                [`al-pdp-vc__panel-item--${slugify(option.option)}`]: true,
            })}
        >
            {option.merchandising_tag && (
                <aside className={styles.tag}>{option.merchandising_tag}</aside>
            )}
            <CloudinaryImage
                type={option.primary_image ? "fetch" : "upload"}
                cldId={option.primary_image?.image}
                cldSrcSet={[108, 216, 324, 432]}
                aspectRatio="1:1"
                crop="pad"
            >
                <img alt="" sizes="108px" />
            </CloudinaryImage>
            <span className={styles.name}>{option.option}</span>
        </ListBoxItem>
    );
}
